// Enrollment pages (email step, guest checkout, completion) deliberately reuse
// the sign-in page's building blocks - same gradient background, card, logo,
// inputs and button - so the whole enroll flow looks like /login.
import styled from 'styled-components';
import { AuthContainer, AuthCard, Logo } from '../../app/App.styles';
import {
  Form, FormGroup, InputWrapper, Input, Icon, PasswordToggle, Button, LoadingSpinner, GreetingWrapper
} from '../auth/SimpleLogin.styles';

export {
  AuthContainer as Container, AuthCard as Card, Logo,
  Form, FormGroup, InputWrapper, Input, Icon, PasswordToggle, Button, LoadingSpinner, GreetingWrapper
};

export const Title = styled.h2`
  text-align: center;
  margin: 0 0 0.5rem;
  color: var(--text-primary);
  font-family: 'Inter', sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
`;

export const Subtitle = styled.p`
  text-align: center;
  margin: 0 0 1.5rem;
  color: var(--text-secondary);
  font-family: 'Inter', sans-serif;
  font-size: 0.875rem;
  line-height: 1.5;
`;

// Same look as the sign-in page's error banner.
export const ErrorMessage = styled.div`
  background: rgba(220, 53, 69, 0.08);
  border: 1px solid rgba(220, 53, 69, 0.25);
  border-radius: var(--card-radius);
  color: rgba(220, 53, 69, 0.95);
  padding: 1rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: left;

  /* Icon sits on the first line (1.5 * 0.875rem tall) and keeps its size when the text wraps. */
  > svg {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    margin-top: calc((1.3125rem - 1.25rem) / 2);
  }
`;

// Standalone (non-button) spinner: the sign-in spinner is white-on-primary.
export const PageSpinner = styled.div`
  width: 28px;
  height: 28px;
  margin: 0 auto 1rem;
  border: 3px solid var(--border-color);
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  animation: enrollSpin 1s linear infinite;

  @keyframes enrollSpin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: var(--primary-color);
  font-size: inherit;
  font-family: inherit;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid var(--focus-ring);
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const FooterText = styled.div`
  text-align: center;
  margin-top: 1rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
`;
